function mapProducts(lineItems){
            return lineItems.map(x => {
                        return {
                                    id: x.id,
                                    title: x.title,
                                    primaryAuthor: x.product.vendor,
                                    isbn: parseInt(x.variant.sku),
                                    format: x.product.productType,
                                    quantity: parseInt(x.quantity),
                                    price: parseFloat(x.variant.price.amount),
                                    coverURL: x.variant.image ? x.variant.image.src : null
                        }
            })
}

export default mapProducts;

// let sampleCart = [{id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxNzA1ODExNTc0NA==', title: 'Delicious Foods', primaryAuthor: 'James Hannaham', format: 'Trade Paperback', quantity: 1, price: 16.99, coverURL: 'https://www.hachettebookgroup.com/wp-content/uploads/2017/06/9780316284936.jpg?fit=450%2C675'},{id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxNzA2MjM3NTU4NA==', title: 'How the Word Is Passed', primaryAuthor: 'Clint Smith', format: 'Hardcover', quantity: 1, price: 29, coverURL: 'https://www.hachettebookgroup.com/wp-content/uploads/2022/01/9780316492935.jpg?fit=435%2C675'}];
// const sampleProduct = [
//             {
//                 "id": "Z2lkOi8vc2hvcGlmeS9DaGVja291dExpbmVJdGVtLzQxODEzOTQxNzgwNjQwMD9jaGVja291dD01OWUzMzhhODc4MTViYzU4MGMwMDg4MTZlMmVlZTZmNQ==",
//                 "title": "On a Night of a Thousand Stars",
//                 "variant": {
//                     "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxMzk0MTc4MDY0MA==",
//                     "title": "Default Title",
//                     "price": "28.00",
//                     "priceV2": {
//                         "amount": "28.0",
//                         "currencyCode": "USD",
//                         "type": {
//                             "name": "MoneyV2",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "amount": "Decimal",
//                                 "currencyCode": "CurrencyCode"
//                             },
//                             "implementsNode": false
//                         }
//                     },
//                     "weight": 0,
//                     "available": true,
//                     "sku": "9781538720295",
//                     "compareAtPrice": null,
//                     "compareAtPriceV2": null,
//                     "image": {
//                         "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0SW1hZ2UvMzE3MTEwMzkzMjQzMjA=",
//                         "src": "https://cdn.shopify.com/s/files/1/0606/0215/5168/products/9781538720295_9c7ddb9b-a989-487a-a0ed-c610e4b47ab7.jpg?v=1646345120",
//                         "altText": null,
//                         "width": 298,
//                         "height": 450,
//                         "type": {
//                             "name": "Image",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "altText": "String",
//                                 "height": "Int",
//                                 "id": "ID",
//                                 "originalSrc": "URL",
//                                 "src": "URL",
//                                 "width": "Int"
//                             },
//                             "implementsNode": false
//                         }
//                     },
//                     "selectedOptions": [
//                         {
//                             "name": "Title",
//                             "value": "Default Title",
//                             "type": {
//                                 "name": "SelectedOption",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "name": "String",
//                                     "value": "String"
//                                 },
//                                 "implementsNode": false
//                             }
//                         }
//                     ],
//                     "unitPrice": null,
//                     "unitPriceMeasurement": {
//                         "measuredType": null,
//                         "quantityUnit": null,
//                         "quantityValue": 0,
//                         "referenceUnit": null,
//                         "referenceValue": 0,
//                         "type": {
//                             "name": "UnitPriceMeasurement",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "measuredType": "UnitPriceMeasurementMeasuredType",
//                                 "quantityUnit": "UnitPriceMeasurementMeasuredUnit",
//                                 "quantityValue": "Float",
//                                 "referenceUnit": "UnitPriceMeasurementMeasuredUnit",
//                                 "referenceValue": "Int"
//                             },
//                             "implementsNode": false
//                         }
//                     },
//                     "product": {
//                         "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzcyNzk0NDU5OTk3NzY=",
//                         "handle": "on-a-night-of-a-thousand-stars",
//                         "type": {
//                             "name": "Product",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "availableForSale": "Boolean",
//                                 "createdAt": "DateTime",
//                                 "description": "String",
//                                 "descriptionHtml": "HTML",
//                                 "handle": "String",
//                                 "id": "ID",
//                                 "images": "ImageConnection",
//                                 "onlineStoreUrl": "URL",
//                                 "options": "ProductOption",
//                                 "productType": "String",
//                                 "publishedAt": "DateTime",
//                                 "title": "String",
//                                 "updatedAt": "DateTime",
//                                 "variants": "ProductVariantConnection",
//                                 "vendor": "String"
//                             },
//                             "implementsNode": true
//                         }
//                     },
//                     "type": {
//                         "name": "ProductVariant",
//                         "kind": "OBJECT",
//                         "fieldBaseTypes": {
//                             "availableForSale": "Boolean",
//                             "compareAtPrice": "Money",
//                             "compareAtPriceV2": "MoneyV2",
//                             "id": "ID",
//                             "image": "Image",
//                             "price": "Money",
//                             "priceV2": "MoneyV2",
//                             "product": "Product",
//                             "selectedOptions": "SelectedOption",
//                             "sku": "String",
//                             "title": "String",
//                             "unitPrice": "MoneyV2",
//                             "unitPriceMeasurement": "UnitPriceMeasurement",
//                             "weight": "Float"
//                         },
//                         "implementsNode": true
//                     }
//                 },
//                 "quantity": 1,
//                 "customAttributes": [],
//                 "discountAllocations": [],
//                 "type": {
//                     "name": "CheckoutLineItem",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "customAttributes": "Attribute",
//                         "discountAllocations": "DiscountAllocation",
//                         "id": "ID",
//                         "quantity": "Int",
//                         "title": "String",
//                         "variant": "ProductVariant"
//                     },
//                     "implementsNode": true
//                 },
//                 "hasNextPage": {
//                     "value": true
//                 },
//                 "hasPreviousPage": false,
//                 "variableValues": {
//                     "checkoutId": "Z2lkOi8vc2hvcGlmeS9DaGVja291dC81OWUzMzhhODc4MTViYzU4MGMwMDg4MTZlMmVlZTZmNT9rZXk9NWQ1NTdhNWZjZjcyNjE1YjY4NWRhZDg5OGU1MmU0MWQ=",
//                     "lineItems": [
//                         {
//                             "variantId": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxMzk0MTc4MDY0MA==",
//                             "quantity": 1
//                         }
//                     ]
//                 }
//             },
//             {
//                 "id": "Z2lkOi8vc2hvcGlmeS9DaGVja291dExpbmVJdGVtLzQxODE3MDU4MTE1NzQ0MD9jaGVja291dD01OWUzMzhhODc4MTViYzU4MGMwMDg4MTZlMmVlZTZmNQ==",
//                 "title": "Delicious Foods",
//                 "variant": {
//                     "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxNzA1ODExNTc0NA==",
//                     "title": "Default Title",
//                     "price": "16.99",
//                     "priceV2": {
//                         "amount": "16.99",
//                         "currencyCode": "USD",
//                         "type": {
//                             "name": "MoneyV2",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "amount": "Decimal",
//                                 "currencyCode": "CurrencyCode"
//                             },
//                             "implementsNode": false
//                         }
//                     },
//                     "weight": 0,
//                     "available": true,
//                     "sku": "9780316284936",
//                     "compareAtPrice": null,
//                     "compareAtPriceV2": null,
//                     "image": {
//                         "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0SW1hZ2UvMzE3MTY2MTc1ODQ4MDA=",
//                         "src": "https://cdn.shopify.com/s/files/1/0606/0215/5168/products/9780316284936.jpg?v=1646412373",
//                         "altText": null,
//                         "width": 298,
//                         "height": 447,
//                         "type": {
//                             "name": "Image",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "altText": "String",
//                                 "height": "Int",
//                                 "id": "ID",
//                                 "originalSrc": "URL",
//                                 "src": "URL",
//                                 "width": "Int"
//                             },
//                             "implementsNode": false
//                         }
//                     },
//                     "selectedOptions": [
//                         {
//                             "name": "Title",
//                             "value": "Default Title",
//                             "type": {
//                                 "name": "SelectedOption",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "name": "String",
//                                     "value": "String"
//                                 },
//                                 "implementsNode": false
//                             }
//                         }
//                     ],
//                     "unitPrice": null,
//                     "unitPriceMeasurement": {
//                         "measuredType": null,
//                         "quantityUnit": null,
//                         "quantityValue": 0,
//                         "referenceUnit": null,
//                         "referenceValue": 0,
//                         "type": {
//                             "name": "UnitPriceMeasurement",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "measuredType": "UnitPriceMeasurementMeasuredType",
//                                 "quantityUnit": "UnitPriceMeasurementMeasuredUnit",
//                                 "quantityValue": "Float",
//                                 "referenceUnit": "UnitPriceMeasurementMeasuredUnit",
//                                 "referenceValue": "Int"
//                             },
//                             "implementsNode": false
//                         }
//                     },
//                     "product": {
//                         "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzcyODA1MzcxMDg2NDA=",
//                         "handle": "delicious-foods-2",
//                         "type": {
//                             "name": "Product",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "availableForSale": "Boolean",
//                                 "createdAt": "DateTime",
//                                 "description": "String",
//                                 "descriptionHtml": "HTML",
//                                 "handle": "String",
//                                 "id": "ID",
//                                 "images": "ImageConnection",
//                                 "onlineStoreUrl": "URL",
//                                 "options": "ProductOption",
//                                 "productType": "String",
//                                 "publishedAt": "DateTime",
//                                 "title": "String",
//                                 "updatedAt": "DateTime",
//                                 "variants": "ProductVariantConnection",
//                                 "vendor": "String"
//                             },
//                             "implementsNode": true
//                         }
//                     },
//                     "type": {
//                         "name": "ProductVariant",
//                         "kind": "OBJECT",
//                         "fieldBaseTypes": {
//                             "availableForSale": "Boolean",
//                             "compareAtPrice": "Money",
//                             "compareAtPriceV2": "MoneyV2",
//                             "id": "ID",
//                             "image": "Image",
//                             "price": "Money",
//                             "priceV2": "MoneyV2",
//                             "product": "Product",
//                             "selectedOptions": "SelectedOption",
//                             "sku": "String",
//                             "title": "String",
//                             "unitPrice": "MoneyV2",
//                             "unitPriceMeasurement": "UnitPriceMeasurement",
//                             "weight": "Float"
//                         },
//                         "implementsNode": true
//                     }
//                 },
//                 "quantity": 1,
//                 "customAttributes": [],
//                 "discountAllocations": [],
//                 "type": {
//                     "name": "CheckoutLineItem",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "customAttributes": "Attribute",
//                         "discountAllocations": "DiscountAllocation",
//                         "id": "ID",
//                         "quantity": "Int",
//                         "title": "String",
//                         "variant": "ProductVariant"
//                     },
//                     "implementsNode": true
//                 },
//                 "hasNextPage": false,
//                 "hasPreviousPage": {
//                     "value": true
//                 },
//                 "variableValues": {
//                     "checkoutId": "Z2lkOi8vc2hvcGlmeS9DaGVja291dC81OWUzMzhhODc4MTViYzU4MGMwMDg4MTZlMmVlZTZmNT9rZXk9NWQ1NTdhNWZjZjcyNjE1YjY4NWRhZDg5OGU1MmU0MWQ=",
//                     "lineItems": [
//                         {
//                             "variantId": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxMzk0MTc4MDY0MA==",
//                             "quantity": 1
//                         }
//                     ]
//                 }
//             }
//         ]